module.exports = __webpack_public_path__ + "static/media/Feather.a76d3097.ttf";